import { ReactElement, useEffect, useMemo, useState } from "react";
import { RootState } from "../../store/store";
import { useSelector } from "react-redux";

import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { NavigationLink } from "../../models/NavigationLink.model";

import "./Header.scss";

import { getLogo } from "../../store/theme/theme.slice";
import PocketBase from "pocketbase";

function Header(): ReactElement {
  const pb = useMemo(() => new PocketBase(process.env.REACT_APP_API_URL), []);
  const profile = useSelector((state: RootState) => state.profile);
  const logo = useSelector(getLogo);

  const [links, setLinks] = useState<NavigationLink[] | null>(null);

  useEffect(() => {
    fetchLinks();
  }, [pb, profile, links]);

  const fetchLinks = async () => {
    if (!links && profile?.id) {
      const { data } = await pb
        .collection("navigation")
        .getFirstListItem(`profile="${profile.id}"`);

      if (data) {
        setLinks(data);
      }
    }
  };

  const renderLink = (links: NavigationLink[]): ReactElement[] => {
    return links.map(({ link, label, children }, index) => {
      const ele: ReactElement = !children ? (
        <LinkContainer key={link + index} to={link}>
          <Nav.Link>{label}</Nav.Link>
        </LinkContainer>
      ) : (
        <NavDropdown
          key={link + index}
          title={label}
          id={label.toLowerCase() + "-id"}
        >
          {children.map(({ link, label }, index) => (
            <LinkContainer key={link + index} to={link}>
              <NavDropdown.Item>{label}</NavDropdown.Item>
            </LinkContainer>
          ))}
        </NavDropdown>
      );
      return ele;
    });
  };

  return (
    <Navbar expand="lg" sticky="top" className="app-header">
      <Container fluid>
        <Navbar.Brand>
          <Link to={"/"}>
            <img
              className="img-fluid logo"
              src={logo}
              alt={profile?.appName || ""}
            />
          </Link>
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav" className="justify-content-end">
          <Nav>{links !== null && links.length && renderLink(links)}</Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Header;
